import { MessageService } from 'primeng/api';
import { Inject, Injectable } from '@angular/core';
import { HttpService } from '../../wrappers/Http';
import { TranslateService } from '@ngx-translate/core';
import { SportServicesService } from '../sport-service/sport-services.service';
import { HelperFunctions } from '../helper-functions';
import { ConfigService } from '../config.service';
import { LoginData } from 'src/app/interface/admin-user';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { STORAGE_KEYS } from '@enum/storage-keys.enum';
import { Router } from '@angular/router';
import { UiService } from '../ui/ui.service';


@Injectable({
  providedIn: 'root'
})
export class UserManagerService {
  logindata: LoginData = {
    authenticated: false,
    privileges: [],
    message: '',
    menu: [],
    info: {}
  };
  private _sideMenu = {
    submenu : 0,
    expanded : true
  };
  hasPreviouslyLoggedIn = false;
  isLoggedIn =  false;
  private currency = {value: ''};

  public get sideMenu() {
    return this._sideMenu;
  }
  public set sideMenu(value) {
    this._sideMenu = value;
  }
  userIdleTime = 0;
  idleInterval = null;
  constructor(private requestHandler: HttpService,
              private translate: TranslateService,
              private httpService: HttpService,
              private messageServrice: MessageService,
              private configService: ConfigService,
              private helperFunction: HelperFunctions,
              private sportService: SportServicesService,
            @Inject(SESSION_STORAGE) private storage: WebStorageService,
          private router: Router,
          private uiService: UiService) { }

  login(matricule: string, password: string): Promise<any> {
    const params = {
      username: matricule,
      password,
      // filterPrefix: 'SPORTS_'
    };
    return new Promise((resolve, reject) => {
        let gw = this.configService.GATEWAY_AGENT;
        // let gw = "http://10.12.1.185:9003";
      this.requestHandler.Post(gw + this.configService.ServiceUrls.login, params).then(response => {
        if (response && response.hasOwnProperty('authenticated') && response.authenticated) {
          if (response.hasOwnProperty('info') && !response.info.hostRestrict) {
            this.logindata = response;
            this.isLoggedIn = true;
            this.sportService.loadParameters({});
            if (this.logindata.info.hasOwnProperty('lang')) {
              const lang = this.uiService.getSupportedLanguage(this.logindata.info.lang.name.toString().toLowerCase());
              this.translate.setDefaultLang(lang);
            }
            if (this.logindata.privileges.length === 0) {
              resolve({error: true, msg: this.translate.instant('no_priviledges_assigned')});
            }
            if(response.info.changePWNextLogin) {
              resolve({error: true, msg: 'ml_password_reset_default_notice', status: '106'});
            }
            resolve({error: false, msg: ''});
          } else {
            resolve({error: true, msg: this.translate.instant('this_host_has_been_restricted')});
          }
        } else {
          resolve({error: true, msg: this.translate.instant(response.msg ? response.msg : response.message), status: response.status? response.status : 0});
        }
      }).catch(msg => {
        resolve({error: true, msg: this.translate.instant('server_error')});
      });
    });
  }
  hasPrevilleges(code: string): boolean {
    for (const previlege of this.logindata.privileges) {
      if (previlege.name === code) {
        return true;
      }
    }
    return false;
  }
  hasMenu(key: string): any {
    for (const menu of this.logindata.menu) {
      if (menu.key === key) {
        const params = {};
        menu.children.forEach(element => {
          params[element.key] = element;
        });
        return {show: true, children: params};
      }
    }
    return {show: false, children: {}};
  }

  cancelTicketPayment(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/v1/transaction/cancel', params);
  }
  changePassword_Old(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN_ + "/agent-servicev2/user/changePassword" + '', params);
  }
  changePassword(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_AGENT + "/agent-servicev2/user/reset-password" + '', params);
  }
  suspendTicketPayment(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  invalidateTicketPayment(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  reimburseTicketPayment(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  suspendClientPayments(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  customersDoActions(params, demo: boolean = false): Promise<any> {
    let gateWay = demo ? this.configService.DEMO_GATEWAY : this.configService.GATEWAY_AGENT
    return this.httpService.Post(gateWay + '/agent-service/customer/update', params);
  }
  sportsDoActions(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/admin/sport/update', params);
  }
  categoriesDoActions(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/admin/category/update', params);
  }
  eventsDoActions(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/admin/sportEvents/update', params);
  }
  tournamentsDoActions(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/admin/tournament/update', params);
  }
  marketsDoActions(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/admin/market/update', params);
  }
  eventMarketsDoActions(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/admin/event/markets/update', params);
  }
  eventSettlementDoActions(params, url){
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls[url], params);
  }
  suspendSportsPayments(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  suspendSportBetting(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  suspendCategoriesPayments(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  suspendCategoryBetting(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  suspendTournamentPayments(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  suspendTournamentBetting(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '', params);
  }
  getCurrency() {
    if (Array.isArray(this.sportService.parameters)) {
      [this.currency] = this.sportService.parameters.filter(parameter => {
        return parameter.key === 'STR_CURRENCY';
      });
      this.currency = !this.currency || !this.currency.hasOwnProperty('value') ? {value: ''} : this.currency;
    }
    this.currency.value ==='TND'? this.currency.value = 'DT' : '';
    return this.currency.value;
  }
  getParameter(key) {
    let paramValue: any = {};
    if (Array.isArray(this.sportService.parameters)) {
      [paramValue] = this.sportService.parameters.filter(parameter => {
        return parameter.key === key;
      });
      paramValue = !paramValue || !paramValue.hasOwnProperty('value') ? {value: null} : paramValue;
    }
    return paramValue.value;
  }
  confirmAccountBlock(clientDetail, params) {
    let msg;
    msg = params.actions.hasOwnProperty('is_blocked') ? this.translate.instant('do_you_want_to_block') + ' ' +`${clientDetail.uname}?` : this.translate.instant('do_you_want_to_unblock')+ ' ' + `${clientDetail.uname}?`
//  console.log("the block message", msg)
    this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?', ' ', msg).then(result => {
      if (result.value) {
        this.helperFunction.presentAlertLoader();
        this.customersDoActions(params).then(data => {
        this.helperFunction.close();
        if (data && data.hasOwnProperty('erc') && data.erc === '1') {
          // tslint:disable-next-line: max-line-length
          if(params.actions['is_blocked']){
            clientDetail['status']='blocked';
          }else if(params.actions['is_enabled']){
            clientDetail['status']='enabled';
            // console.log(clientDetail,"do you need more informations about the client??");

          }
          this.helperFunction.presentAlert('success', this.translate.instant('success'), this.translate.instant('operation_successfull'), null, null);
        } else {
          // tslint:disable-next-line: max-line-length
          this.helperFunction.presentAlert('error', this.translate.instant('failed'), data.msg ? data.msg : this.translate.instant('something_went_wrong'), null, null);
        }
        }).catch(err => {
          this.helperFunction.close();
          console.log(err);
          this.helperFunction.presentAlert('error', this.translate.instant('failed'), this.translate.instant('server_error'), null, null);
        });
      }
    });
  }
  manangeTicket(tickets, action) {
    // console.log(action, tickets);
    const translateObject = {name: this.translate.instant('tickets')};
    if (!tickets.length) {
      this.messageServrice.add({severity: 'error', summary: this.translate.instant('no_item_seleted', translateObject), detail: ''});
      return;
    }
    let message  = '';
    let request = null;
    switch (action.key) {
      case 'cancel_ticket':
        message  = this.translate.instant('cancel_payments_for_ticket', {name: ''});
        this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?', '', message).then(result => {
          if (result.value) {
            request = this.cancelTicketPayment({});
          }
        });
        break;
      case 'suspend_ticket':
        message =  this.translate.instant('suspend_payments_for_ticket', {name: ''});
        this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?', '', message).then(result => {
          if (result.value) {
            request = this.suspendTicketPayment({});
          }
        });
        break;
      case 'invalidate_ticket':
        message = this.translate.instant('invalidate_payments_for_ticket', {name: ''});
        this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?', '', message).then(result => {
          if (result.value) {
            request = this.invalidateTicketPayment({});
          }
        });
        break;
      case 'reimburse_ticket':
        message =  this.translate.instant('reimburse_payments_for_ticket', {name: ''});
        this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?', '', message).then(result => {
          if (result.value) {
            request = this.reimburseTicketPayment({});
          }
        });
        break;
    }
    if (request != null) {
      this.helperFunction.presentAlertLoader();
      request.then(data => {
        this.helperFunction.close();
        if (data && data.hasOwnProperty('erc') && data.erc === '1') {
          // tslint:disable-next-line: max-line-length
          this.helperFunction.presentAlert('success', this.translate.instant('success'), this.translate.instant('operation_successfull'), null, null);
        } else {
          // tslint:disable-next-line: max-line-length
          this.helperFunction.presentAlert('error', this.translate.instant('failed'), data.msg ? data.msg : this.translate.instant('something_went_wrong'), null, null);
        }
      }).catch(err => {
        this.helperFunction.close();
        console.log(err);
        this.helperFunction.presentAlert('error', this.translate.instant('failed'), this.translate.instant('server_error'), null, null);
      });
    }
  }
  sendMessage(params) {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/customer/notif', params);
  }
  modifyCustomer(userInfo, params, message, demo: boolean = false) {
    this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?', '', message).then(result => {
      if (result.value) {
        this.helperFunction.presentAlertLoader();
        this.customersDoActions(params, demo).then(data => {
        this.helperFunction.close();
        if (data && data.hasOwnProperty('erc') && data.erc === '1') {
          // tslint:disable-next-line: max-line-length
          this.helperFunction.presentAlert('success', this.translate.instant('success'), this.translate.instant('operation_successfull'), null, null);
          userInfo[Object.keys(params.actions)[0]] = params.actions[Object.keys(params.actions)[0]];
          if(params.actions['is_suspended']){
            userInfo['status']='suspended';
          }else if(params.actions['is_enabled']){
            userInfo['status']='enabled';

          }
          // console.log(userInfo);
        } else {
          // tslint:disable-next-line: max-line-length
          this.helperFunction.presentAlert('error', this.translate.instant('failed'), data.msg ? data.msg : this.translate.instant('something_went_wrong'), null, null);
        }
        }).catch(err => {
          this.helperFunction.close();
          console.log(err);
          this.helperFunction.presentAlert('error', this.translate.instant('failed'), this.translate.instant('server_error'), null, null);
        });
      }
    });
  }

  phoneNumberTaken(params: { phone: string }) {
    return from(this.requestHandler.Hget(
      this.configService.DEMO_GATEWAY, `/v2/user/validate-phn`,
      params, true
    )).pipe(map((res) => {
      if(res.hasOwnProperty('erc') && res.erc == '1'){
        return { result: res.data ? true : false, error: false};
      }
      return { result: false, error: true };
    }));
  }

  emailTaken(params: { email: string }) {
    return from(this.requestHandler.Hget(
      this.configService.DEMO_GATEWAY, `/v2/user/validate-email`,
      params, true
    )).pipe(map((res) => {
      if(res.hasOwnProperty('erc') && res.erc == '1'){
        return { result: res.data ? true : false, error: false};
      }
      return { result: false, error: true };
    }));
  }

  userNameTaken(params: { username: string }) {
    return from(this.requestHandler.Hget(
      this.configService.DEMO_GATEWAY, `/v2/user/validate-user`,
      params, true
    )).pipe(map((res) => {
      if(res.hasOwnProperty('erc') && res.erc == '1'){
        return { result: res.data ? true : false, error: false};
      }
      return { result: false, error: true };
    }));
  }

  logoutAgent() {
    this.logindata = {
      authenticated: false,
      privileges: [],
      message: '',
      menu: [],
      info: {}
    };
    this.isLoggedIn = false;
    this.hasPreviouslyLoggedIn = false;
    this.storage.set(STORAGE_KEYS.LOGIN, '');
    this.router.navigate(['/']);
  }
}
